import { App, View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout, PMLevelCard } from "@pimo/pimo-components";

import { TestAppState } from "../../../app";
import { isFieldEnabled } from "../../field-enabled";
import { makeGetCardCopy } from "../card-copy";

/** Adds the overall completion card (#2222). */
export function addCompletionCard(
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
) {
  const language = app.getAppState().language || "en";
  const getCardCopy = makeGetCardCopy(app);

  const completionCard = view.addComponent({
    component: PMLevelCard,
    layoutProps: {
      componentId: "completionCard",
      title: getCardCopy(language, "reportCompletion").title,
      description: getCardCopy(language, "reportCompletion").description,
      labels: ["overallCompletion"],
    },
  });

  completionCard.mapLayoutProps(({ language }) => {
    const currentLanguage = language || "en";
    return {
      componentId: "completionCard",
      title: getCardCopy(currentLanguage, "reportCompletion").title,
      description: getCardCopy(currentLanguage, "reportCompletion").description,
      labels: ["overallCompletion"],
    };
  });

  completionCard.mapState(({ currentReport, settings, language }) => {
    const currentLanguage = language || "en";
    return {
      title: getCardCopy(currentLanguage, "reportCompletion").title,
      categories: [
        {
          value:
            currentReport?.project?._calculated?.overallDegreeOfCompletion
              ?.name ?? "",
          valueColor:
            settings?.configuration?.degreeOfCompletionDefinition?.find(
              (cat) =>
                cat.name ===
                currentReport?.project?._calculated?.overallDegreeOfCompletion
                  ?.name
            )?.color ?? "#E1F1E7",
          textColor: "#fff",
        },
      ],
      showInfoIcon: false,
      showMenuIcon: false,
    };
  });

  completionCard.mapVisibility(({ settings }) =>
    isFieldEnabled(settings, "completion", "itemReporting")
  );
}
